"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const icon_1 = tslib_1.__importDefault(require("antd/es/icon"));
const menu_1 = tslib_1.__importDefault(require("antd/es/menu"));
const MenuItem_1 = tslib_1.__importDefault(require("antd/es/menu/MenuItem"));
const SubMenu_1 = tslib_1.__importDefault(require("antd/es/menu/SubMenu"));
const SVG_1 = require("../SVG");
exports.HorizontalMenu = (_a) => {
    var { updateLanguage, languages, mobileImg, currentLanguage, children, className } = _a, leftOvers = tslib_1.__rest(_a, ["updateLanguage", "languages", "mobileImg", "currentLanguage", "children", "className"]);
    const classes = `clp-horizontal-menu ${className ? className : ''}`;
    const [isVisibleModal, setIsVisibleModal] = react_1.useState(false);
    const toggleModal = () => setIsVisibleModal(prevState => !prevState);
    return (React.createElement(React.Fragment, null,
        React.createElement(menu_1.default, Object.assign({ overflowedIndicator: React.createElement(icon_1.default, { type: "menu", className: "icon-expand", onClick: toggleModal }), mode: "horizontal", className: classes }, leftOvers),
            children,
            React.createElement(menu_1.default.SubMenu, { popupClassName: "clp-antd-submenu clp-antd-submenu_xs tt-u", key: "language", title: React.createElement("div", { className: "tt-u" },
                    currentLanguage,
                    " ",
                    React.createElement(SVG_1.SvgArrowLang, null)) }, languages.map(item => {
                return (React.createElement(menu_1.default.Item, { onClick: () => updateLanguage(item), key: item }, item));
            }))),
        isVisibleModal && (React.createElement("div", { className: "clp-sub-menu" },
            React.createElement("img", { src: mobileImg, alt: "mobile menu", className: "clp-sub-menu__img" }),
            React.createElement(menu_1.default, Object.assign({}, leftOvers, { mode: "inline", onClick: toggleModal }),
                React.createElement(MenuItem_1.default, null,
                    React.createElement(SVG_1.SvgClose, null)),
                children,
                React.createElement(SubMenu_1.default, { key: "language", title: currentLanguage, className: "submenu_transparent tt-u", popupClassName: "tt-u" }, languages.map(item => {
                    return (React.createElement(menu_1.default.Item, { className: item === currentLanguage ? 't_bold' : 't_normal', onClick: () => updateLanguage(item), key: item }, item));
                })))))));
};
//# sourceMappingURL=HorizontalMenu.js.map